class Location {
	id = null;
	name = '';
	city_id = null;
	county_id = null;
	descriptions = [];

	constructor(data) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}
	}
}

export default Location;
